import React from 'react';
import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const items=[ 
  {title: "Banho & Tosa de Excelência",desc: "Técnicas de tosa tesoura e equipamentos de última geração que respeitam a fisiologia e o bem-estar do seu pet.",icon: "Scissors"},
  {title: "Acesso Antecipado",desc: "Prioridade absoluta na reserva de horários em datas festivas e períodos de alta demanda para membros cadastrados.",icon: "CheckCircle"},
  {title: "Cuidado & Atenção",desc: "Atenção individualizada em cada detalhe, utilizando as melhores linhas de cosmética pet para garantir saúde e brilho.",icon: "Heart"} 
];

const Benefits=()=> {
  const scrollToForm = () => document.getElementById('cadastro')?.scrollIntoView({behavior: 'smooth'});

  return ( 
    <section className="py-24 bg-[#FAF8F5]"> 
      <div className="max-w-7xl mx-auto px-6"> 
        <div className="grid grid-cols-1 md:grid-cols-3 gap-16 lg:gap-24 mb-20"> 
          {items.map((item,i)=> ( 
            <motion.div key={i} initial={{opacity: 0,y: 20}} whileInView={{opacity: 1,y: 0}} viewport={{once: true}} transition={{delay: i * 0.1,duration: 0.8}} className="text-center group" > 
              <div className="relative w-12 h-12 mx-auto mb-8"> 
                <div className="absolute inset-0 bg-amber-700/5 rounded-full scale-150 group-hover:bg-amber-700/10 transition-colors" /> 
                <SafeIcon name={item.icon} className="w-full h-full text-amber-800 relative z-10" /> 
              </div> 
              <h3 className="font-serif text-2xl font-bold text-stone-900 mb-5 leading-tight">{item.title}</h3> 
              <p className="text-stone-600 leading-relaxed font-medium px-4">{item.desc}</p> 
            </motion.div> 
          ))} 
        </div> 

        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="flex justify-center"
        >
          <button 
            onClick={scrollToForm}
            className="group flex items-center gap-4 border-2 border-stone-900 text-stone-900 px-8 py-4 rounded-xl font-bold uppercase tracking-[0.2em] text-[10px] hover:bg-stone-900 hover:text-white transition-all shadow-sm"
          >
            Quero esse cuidado para meu pet <SafeIcon name="ArrowRight" className="w-4 h-4" />
          </button>
        </motion.div>
      </div> 
    </section> 
  );
};

export default Benefits;